module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Base_03.9af81794.png";